import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { axiosOpen } from "../../api/axios";
import CheckoutForm from "./CheckoutForm";
import { SuccessfulTransaction, FailedTransaction } from "../../Pages/"

const Payment = () => {
  const { planID } = useParams();
  const stripePromis = loadStripe("pk_test_NBWPA3NVboDj6my1Q2nVubqG");
  const [planDetails, setPlanDetails] = useState({});
  const [isProcessingPayment, setIsProcessingPayment] = useState('not started');

  let isMounted = useRef(false);


  async function getPlanDetails() {
    try {
      const response = await axiosOpen.get(`subscription/item/${planID}`);
      isMounted && setPlanDetails(response?.data);
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    isMounted = true;
    getPlanDetails();

    return () => isMounted = false;
  }, []);

  return (
    <>
      {
        isProcessingPayment == 'not started' && <div className="checkout-page col-md-6 m-auto shadow p-3 mt-5 bg-white rounded">
          <div className="container">
            <div className="section-title text-center pb-4">
              <h2>PAYMENT DETAILS</h2>
              <h4>Total: ${planDetails?.amount || 0}</h4>
            </div>
            <Elements stripe={stripePromis}>
              <CheckoutForm
                planDetails={planDetails}
                isProcessingPayment={isProcessingPayment}
                setIsProcessingPayment={setIsProcessingPayment}
              />
            </Elements>
          </div>
        </div>
      }
      {
        isProcessingPayment ==='completed' && <SuccessfulTransaction />
      }

      {
        isProcessingPayment ==='failed' && <FailedTransaction />
      }
    </>
  );
};

export default Payment;
